import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import Treatment from '../Treatment';
import { featureFlags } from '../../splitSetup';

export default function MobileBottomNav({ menuItems }) {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(
    menuItems.findIndex((item) =>
      item.paths
        ? item.paths.some((path) => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.to)
    )
  );

  useEffect(() => {
    setValue(
      menuItems.findIndex((item) =>
        item.paths
          ? item.paths.some((path) => location.pathname.startsWith(path))
          : location.pathname.startsWith(item.to)
      )
    );
  }, [location.pathname]);

  return (
    <Treatment
      splitNames={featureFlags.bottom_navigation}
      evaluatedComponent={
        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1300,
            display: 'block',
            '@media (min-width: 800px)': {
              display: 'none',
            },
            paddingBottom: '28px',
          }}
          elevation={3}
        >
          <BottomNavigation
            showLabels
            value={value}
            onChange={(_, newValue) => {
              setValue(newValue);
              const item = menuItems[newValue];
              if (item.onClick) {
                item.onClick();
              } else {
                history.push(item.to);
              }
            }}
          >
            {menuItems.map((item) => (
              <BottomNavigationAction
                key={item.id}
                label={item.shortLabel || item.label}
                icon={item.icon}
              />
            ))}
          </BottomNavigation>
        </Paper>
      }
    />
  );
}
